import { useLocation, useParams } from 'react-router-dom';
import Button from 'src/components/Button';
import Modal from 'src/components/Modal';
import { useDeleteStudentActivityMutation } from 'src/pages/single-student/singleStudentApi';
import { useAppDispatch } from 'src/store';
import { addToast } from 'src/toasts/ToastsSlice';

import { useInvoiceDetailsQuery } from '../billing/billingApi';

type DeleteActivityModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  activityId: string;
};

export const DeleteActivityModal = ({
  open,
  onOpenChange,
  activityId,
}: DeleteActivityModalProps) => {
  const { id } = useParams();
  const location = useLocation();
  const isStudentProfile = location.pathname.includes('student');
  const { data: invoiceData } = useInvoiceDetailsQuery(id!, {
    skip: !id || isStudentProfile,
  });
  const studentId = isStudentProfile ? id! : invoiceData?.studentId || '';
  const [deleteActivity, { isLoading }] = useDeleteStudentActivityMutation();
  const dispatch = useAppDispatch();

  const handleDelete = async () => {
    try {
      await deleteActivity({
        id: studentId,
        activityId,
      }).unwrap();

      dispatch(addToast({ text: 'Activity has been successfully deleted', type: 'positive' }));
      onOpenChange(false);
    } catch (error) {
      dispatch(
        addToast({
          text: 'Failed to delete activity. Please try again later.',
          type: 'negative',
        }),
      );
      console.error('Failed to delete activity:', error);
    }
  };

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      className="w-full max-w-md rounded-lg"
      hideHeader
    >
      <p className="pt-3 text-body-lg-desktop text-neutral-100">
        Are you sure you want to delete this activity?
      </p>
      <div className="flex justify-end gap-2 py-6">
        <Button preset="tertiary" onClick={() => onOpenChange(false)} disabled={isLoading}>
          Cancel
        </Button>
        <Button preset="warning" onClick={handleDelete} isLoading={isLoading}>
          Delete
        </Button>
      </div>
    </Modal>
  );
};
